"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteEspace = UseDeleteEspace;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_2 = require("react");
const react_hook_form_1 = require("react-hook-form");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const yup = __importStar(require("yup"));
const espace_api_1 = require("../../../../utils/api/espace/espace.api");
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const hook_1 = require("../../../../redux/hook");
const categorie_api_1 = require("../../../../utils/api/categorie/categorie.api");
const UseCrudEspace = (handleClose, espace) => {
    const validationSchema = yup.object().shape({
        hasEdit: yup.boolean(),
        name: yup.string().required("Le nom est requis.").label("Nom"),
        category_id: yup
            .string()
            .required("La catégorie est requise.")
            .label("Catégorie"),
        address: yup
            .string()
            .nullable()
            .label("L'addresse"),
        lat: yup.string().label("La latitude est requise"),
        long: yup.string().label("La longitude requise"),
        // image: yup
        //     .mixed()
        //     .when("hasEdit", {
        //         is: false,
        //         then: () =>
        //             yup
        //                 .mixed()
        //                 .required("L'image est requise.")
        //                 .label("Image")
        //                 .transform((val: any) => (!val ? null : val)),
        //         otherwise: () => yup.mixed().nullable(),
        //     })
        //     .nullable(),
    });
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const { register, handleSubmit, formState: { errors }, setValue, clearErrors, reset, } = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(validationSchema),
        defaultValues: {
            added_by: user.user_id,
        },
    });
    const [type, setType] = (0, react_1.useState)(null);
    const [address, setAddress] = (0, react_1.useState)("");
    const [imageFile, setImageFile] = (0, react_1.useState)(null);
    const [addOrUpdateEspace, { isLoading, isSuccess, error, isError }] = (0, espace_api_1.useAddOrUpdateEspaceMutation)();
    const { data = { data: [], count: 0 }, isLoading: isLoadCategorie } = (0, categorie_api_1.useCategorieByTypeQuery)("space");
    const onChangeAddress = (val) => {
        // console.log("selected address", val);
        // setAddress(val?.rue);
        // setValue("address", val?.rue);
        // setValue("lat", val?.latitude);
        // setValue("long", val?.longitude);
        var _a;
        // 1) Saisie libre (pas Google) → val est une string
        if (typeof val === "string") {
            setAddress(val);
            setValue("address", val);
            console.log('val', val);
            return;
        }
        // 2) Sélection Google → val est un objet
        const isGoogle = Boolean(val.place_id) ||
            (val.latitude && val.longitude);
        const text = (_a = val.rue) !== null && _a !== void 0 ? _a : "";
        // On renseigne toujours le texte affiché
        setAddress(text);
        setValue("address", text);
        // On ne renseigne lat/long que pour une vraie adresse Google
        if (isGoogle && val.latitude && val.longitude) {
            setValue("lat", val.latitude);
            setValue("long", val.longitude);
        }
    };
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Espace ${espace ? "modifié" : "ajouté"} avec succès!`,
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1200,
            }).then(() => {
                if (!espace) {
                    reset();
                    setImageFile(null);
                    setAddress("");
                }
                handleClose();
            });
        }
        const err = error;
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message)
                    ? (_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message
                    : `Erreur de statut ${err === null || err === void 0 ? void 0 : err.status}`,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [isLoading]);
    (0, react_2.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors, clearErrors]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        const fd = new FormData();
        if (data.hasEdit) {
            fd.append("_method", "PUT");
        }
        for (let key of Object.keys(data)) {
            if (key === "image") {
                const image = data.image;
                if (data.hasEdit && typeof image === "string") {
                    continue;
                }
                if (image instanceof File || typeof image === "object") {
                    fd.append("image", image);
                }
            }
            else {
                fd.append(key, data[key]);
            }
        }
        console.log("data finale envoyée :", Object.fromEntries(fd.entries()));
        addOrUpdateEspace({ id: espace === null || espace === void 0 ? void 0 : espace.id, data: fd });
    }, [espace === null || espace === void 0 ? void 0 : espace.id, addOrUpdateEspace, data.hasEdit]);
    (0, react_2.useEffect)(() => {
        if (espace === null || espace === void 0 ? void 0 : espace.id) {
            setValue("hasEdit", true);
            let fields = [
                "name",
                "image",
                "address",
                "lat",
                "long",
                "category_id",
            ];
            setImageFile(espace === null || espace === void 0 ? void 0 : espace.image);
            for (let field of fields) {
                register(field);
                setValue(field, espace[field]);
            }
            setAddress(espace === null || espace === void 0 ? void 0 : espace.address);
        }
        else {
            setValue("hasEdit", false);
        }
    }, [espace]);
    (0, react_2.useEffect)(() => {
        if (imageFile === null || imageFile === void 0 ? void 0 : imageFile.name) {
            setValue("image", imageFile);
        }
    }, [imageFile]);
    return {
        register,
        errors: errors,
        onSubmit: handleSubmit(onSubmit),
        setValue,
        isLoading,
        reset,
        type,
        setType,
        address,
        onChangeAddress,
        imageFile,
        setImageFile,
        categories: data === null || data === void 0 ? void 0 : data.data,
    };
};
exports.default = UseCrudEspace;
function UseDeleteEspace(id) {
    const [deleteData] = (0, espace_api_1.useDeleteEspaceMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cet espace ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Espace supprimée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
